import { render } from "./HomeCompareValue.vue?vue&type=template&id=00855872&scoped=true"
import script from "./HomeCompareValue.vue?vue&type=script&lang=js"
export * from "./HomeCompareValue.vue?vue&type=script&lang=js"

import "./HomeCompareValue.vue?vue&type=style&index=0&id=00855872&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-00855872"

export default script